module.exports = __webpack_public_path__ + "static/media/User.c2c435b9.svg";